import React, { useEffect } from 'react';
import { orderNavigationSlice } from '../../../../store/order/orderNavigation/orderNavigationSlice';
import { loadEscrowBalancesAsync } from '../../../../store/order/escrow/escrowBalancesHeaderSlice';
import { SpaOrderEscrowLayout } from './SpaOrderEscrowLayout';
import { SpaEscrowDisbursedTransactionsContainer } from '../../../../components/order/escrow/SpaEscrowDisbursedTransactionsContainer';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';
import { useAppDispatch } from '../../../../store/store';

export const SpaOrderEscrowViewContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(orderNavigationSlice.actions.setup({ tab: 'Escrow' }));
    dispatch(loadEscrowBalancesAsync({ orderId }));
  }, [dispatch, orderId]);

  return (
    <SpaOrderEscrowLayout orderId={orderId}>
      <SpaEscrowDisbursedTransactionsContainer orderId={orderId} />
    </SpaOrderEscrowLayout>
  );
};
